import FBConfig from "../FBConfig";
import { v4 as uuidv4 } from "uuid";

let timeoutId;
class Running_order_firebase {
  OrgId;
  SynckData = (OrgId) => {
    if (sessionStorage.getItem('BYPASS')?.includes('SYNC')) return;
    var refreshId = setInterval(() => {
      if (+localStorage.getItem("refresh_status") === 0) {
        this.ReadIndexDbRuningOrders(this.GetDataAndSynch);
        this.OrgId = OrgId;
        clearInterval(refreshId);
      }
    }, 1000);

    setTimeout(() => {
      clearInterval(refreshId);
    }, 5000);
  };

  GetDataAndSynch = (LocalOrder) => {
    let templocalorder = LocalOrder.filter(function (x) {
      return (x.IsSynched === null || x.IsSynched === 0) && x.outlet_uuid === localStorage.getItem("outlet_uuid");
    });

    for (let i = 0; i < templocalorder.length; i++) {
      var FbInserOrder = JSON.parse(JSON.stringify(templocalorder[i]));
      FbInserOrder.IsSynched = 1;
      FBConfig.set(FBConfig.ref(FBConfig.db, this.OrgId + "/RunnigOrders/" + templocalorder[i].order_uuid),
        FbInserOrder
      ).then(() => {
        // console.log('Successfully set FB value');
        templocalorder[i].IsSynched = 1;

        if (templocalorder[i].Sync_Type)
          delete templocalorder[i].Sync_Type;
        this.UpdatedSynchOrders(templocalorder[i].order_uuid, templocalorder);
      });
    }
  };

  UpdatedSynchOrders = (order_uuid, LocalOrder) => {
    var LocalOrderObj = LocalOrder.find((x) => {
      return x.order_uuid === order_uuid && x.outlet_uuid === localStorage.getItem("outlet_uuid");
    });
    if (LocalOrderObj !== null) {
      var order_kot_details = LocalOrderObj.order_kot_details;
      if (order_kot_details !== null && order_kot_details.length > 0) {
        for (let i = 0; i < order_kot_details.length; i++) {
          order_kot_details[i].IsSynched = 1;
        }
        LocalOrderObj.order_kot_details = order_kot_details;
      }
      this.WriteIndexDbrunnigOrders(LocalOrderObj);
    }
  };

  ReadIndexDbRuningOrders = (
    CallBackFun,
    ExtraaParamValue = null,
    setForceRenderOrdersPage, toggleAlarm,
    setForceRenderPage1
  ) => {
    let DBOpenReq = indexedDB.open("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    DBOpenReq.addEventListener("error", (err) => { return null; });
    DBOpenReq.addEventListener("success", (ev) => {
      var tx = ev.target.result.transaction("running_orders", "readwrite");
      var Running_orders = tx.objectStore("running_orders");
      let getOrders = Running_orders.getAll();
      getOrders.onsuccess = async (orderReq) => {

        let collection = orderReq.target.result;
        if (ExtraaParamValue !== null) {

          const Orders_Store = ev.target.result.transaction("Orders", "readonly").objectStore("Orders");
          const orderGetReq = Orders_Store.get(ExtraaParamValue.order_uuid);

          orderGetReq.onsuccess = orderEvent => {
            const isOrderCompleted = orderEvent.target.result;

            if (isOrderCompleted)
              return
            // console.log('order exists in "Orders" collection.')
            else if (ExtraaParamValue.outlet_uuid === localStorage.getItem("outlet_uuid"))
              CallBackFun(collection, ExtraaParamValue, setForceRenderOrdersPage, toggleAlarm, setForceRenderPage1);
          }
        } else
          CallBackFun(collection, null, setForceRenderOrdersPage, toggleAlarm, setForceRenderPage1);
      };
    });
  };

  WriteIndexDbrunnigOrders(ObjOrder) {
    let DBOpenReq = indexedDB.open("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    // console.log('idb collection opened on', window.location.pathname)
    DBOpenReq.addEventListener("error", (err) => { console.warn(err); });
    DBOpenReq.addEventListener("success", (ev) => {

      const Orders_Store = ev.target.result.transaction("Orders", "readonly").objectStore("Orders");
      const orderGetReq = Orders_Store.get(ObjOrder.order_uuid);

      orderGetReq.onsuccess = orderEvent => {
        const completedOrder = orderEvent.target.result;

        if (completedOrder)
          return
        //  console.log(`Order number ${completedOrder.local_order_id} is completed and exists in orders table`);

        else if (ObjOrder.outlet_uuid === localStorage.getItem("outlet_uuid")) {
          // console.log("order is not completed")
          var TblrRunningOrder = ev.target.result.transaction("running_orders", "readwrite");
          var store = TblrRunningOrder.objectStore("running_orders");
          store.put(ObjOrder);
        }
      }
    });
  }

  ReadValueFromFirebase(OrgId, stateProps) {

    const commentsRef = FBConfig.ref(FBConfig.db, OrgId + "/RunnigOrders/");

    FBConfig.onChildAdded(commentsRef, (data) => {
      this.ReadIndexDbRuningOrders(
        this.AddOrUpdateNewOrderInLocalDb,
        data.val(),
        stateProps
      );
    });

    FBConfig.onChildChanged(commentsRef, (data) => {
      this.ReadIndexDbRuningOrders(
        this.AddOrUpdateNewOrderInLocalDb,
        data.val(),
        stateProps
      );
    });

    FBConfig.onChildRemoved(commentsRef, (data) => {
      // console.log(data.val());
      Running_order_firebase.RemoveOrderFromRunningDb(
        data.key,
        data.val(),
        stateProps
      );
    });

    setInterval(() => {
      this.SynckData(localStorage.getItem("outlet_uuid"));
    }, 20000);
  }

  AddOrUpdateNewOrderInLocalDb(
    Localorders,
    NewChildValue,
    stateProps
  ) {
    if (NewChildValue !== null) {

      // console.log(NewChildValue)
      var LocalOrderObj = Localorders.find((x) => {
        return x.order_uuid === NewChildValue.order_uuid;
      });

      let order_requests = JSON.parse(localStorage.getItem("order_requests")) || [];
      if (+NewChildValue.order_status === 0) {
        stateProps.toggleAlarm(true);
        if (!order_requests.includes(NewChildValue.order_uuid)) {
          order_requests.push(NewChildValue.order_uuid);
          localStorage.setItem("order_requests", JSON.stringify(order_requests));
        }
      }
      else if (order_requests.includes(NewChildValue.order_uuid)) {
        order_requests = order_requests.filter(i => i !== NewChildValue.order_uuid);
        localStorage.setItem("order_requests", JSON.stringify(order_requests));
      }

      if (LocalOrderObj === null) {
        Running_order_firebase.UpdateorderInSeating(1, NewChildValue, stateProps);
      } else {
        Running_order_firebase.UpdateorderInSeating(0, NewChildValue, stateProps);
      }
    }
  }

  static UpdateorderInSeating(isNewOrder, ObjOrder, stateProps) {

    const { setForceRenderOrdersPage, setForceRenderPage1, calculateOrderValues } = stateProps
    let DBOpenReq = indexedDB.open("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    DBOpenReq.addEventListener("error", (err) => { console.warn(err); });
    DBOpenReq.addEventListener("success", (ev) => {

      let db = ev.target.result;
      ObjOrder.order_kot_details.sort((a, b) => +a.kot - +b.kot);
      ObjOrder.IDENTIFIER = ObjOrder.order_uuid;

      if (ObjOrder.order_status < 4) {
        let tx = db.transaction("running_orders", "readwrite");
        let store = tx.objectStore("running_orders");

        const gotOrder = store.getAll();
        gotOrder.onsuccess = (orderEvent) => {
          const IDBOrder = orderEvent.target.result?.find(i =>
            i.order_uuid === ObjOrder.order_uuid || (
              ObjOrder?.seat_uuid?.length > 0
              && i.seat_uuid === ObjOrder.seat_uuid
              && i.brand_uuid === ObjOrder.brand_uuid
            ) || i.local_order_id === ObjOrder.local_order_id);

          const updateLocalSeatData = order_json => {
            let onorder_seats = JSON.parse(localStorage.getItem("onorder_seats")) || [];

            let object = {
              seat_uuid: order_json.seat_uuid,
              created_at: order_json.created_at,
              price: order_json.order_total,
              title: order_json.local_order_id,
              uuid: order_json.order_uuid
            };

            if (Array.isArray(order_json.invoice_prints) && order_json.invoice_prints.length > 0)
              object.invoiced = 1;

            if (onorder_seats.length > 0)
              onorder_seats = onorder_seats.filter(
                obj => obj.uuid !== order_json.order_uuid
              );

            onorder_seats.push(object);
            localStorage.setItem("onorder_seats", JSON.stringify(onorder_seats));
          }

          if (IDBOrder && +IDBOrder?.order_status !== 0) {

            console.log({ IDBOrder, ObjOrder })

            const order_kot_details = IDBOrder?.order_kot_details?.map(IDBKot => {
              const FBKot = { ...(ObjOrder?.order_kot_details?.find(i => +i.kot === +IDBKot?.kot) || {}) }
              let kot = +FBKot?.kot_status > +IDBKot?.kot_status ? FBKot : IDBKot
              kot.kot_items_details = IDBKot.kot_items_details?.map(IDBItem => {
                const FBItem = FBKot?.kot_items_details?.find(i => i.item_uuid === IDBItem?.item_uuid) || {}
                if (
                  +FBItem?.order_item_status > +IDBItem?.order_item_status ||
                  +FBItem?.updated_at > +IDBItem?.updated_at
                ) return { ...FBItem }
                else return IDBItem
              }).concat(FBKot?.kot_items_details
                ?.filter(i => !IDBKot?.kot_items_details?.find(j => i.item_uuid === j.item_uuid)))
              return kot
            })?.concat(ObjOrder.order_kot_details
              ?.filter(i => !IDBOrder?.order_kot_details?.find(j => +i.kot === +j.kot)))

            console.log({ order_kot_details })
            let order_json = { ...ObjOrder, order_kot_details: [...order_kot_details?.filter(i => i?.kot)] }
            order_json.IsSynched = IDBOrder?.IsSynched;
            order_json.customer_mobile = ObjOrder.customer_mobile || IDBOrder.customer_mobile
            order_json.customer_name = ObjOrder.customer_name || IDBOrder.customer_name
            order_json.payment_status = +ObjOrder.payment_status || +IDBOrder.payment_status

            const payment_at = ObjOrder.payment_at || IDBOrder.payment_at
            if (payment_at) order_json.payment_at = payment_at

            const payment_by_user_uuid = ObjOrder.payment_by_user_uuid || IDBOrder.payment_by_user_uuid
            if (payment_by_user_uuid) order_json.payment_by_user_uuid = payment_by_user_uuid

            function compareLengths(key) {
              if (ObjOrder[key] || IDBOrder[key])
                order_json[key] = ObjOrder[key]?.length > IDBOrder[key]?.length
                  ? IDBOrder[key]
                  : (ObjOrder[key] || IDBOrder[key])
            }

            compareLengths('payment_details')
            compareLengths('charges_and_discounts')
            compareLengths('comments')
            compareLengths('coupons')
            compareLengths('prepared_items_group')

            tx = db.transaction("item", "readonly");
            store = tx.objectStore("item");

            order_json = calculateOrderValues(order_json, true, true)

            let order_kots = [];
            order_json.order_kot_details.forEach(kot => {
              let matchedKot = order_kots?.find(iKot =>
                +iKot.kot_total === +kot.kot_total
                && +iKot.kot_vat === +kot.kot_vat
                && +iKot.kot_gst === +kot.kot_gst
                && JSON.stringify(iKot.kot_items_details) === JSON.stringify(kot.kot_items_details)
                && +((`${+iKot.created_at - +kot.created_at}`).replace("-", "")) <= 25000
              )
              !matchedKot && order_kots.push(kot);
            })

            ObjOrder.order_kot_details = order_kots;
            console.log('MERGED ORDER', order_json)

            tx = db.transaction("running_orders", "readwrite");
            store = tx.objectStore("running_orders");

            console.log({ MERGEDORDER: order_json, IDBOrder, FBOrder: ObjOrder })
            store.put(order_json);
            if (order_json.seat_uuid) updateLocalSeatData(order_json)
          }
          else {
            console.log({ ObjOrder })
            store.add(ObjOrder)
            if (ObjOrder?.seat_uuid) updateLocalSeatData(ObjOrder)
          }
        }
      }

      else if (ObjOrder.order_status === 4) {
        let tx = db.transaction("Orders", "readwrite");
        let store = tx.objectStore("Orders");
        isNewOrder === 1 ? store.add(ObjOrder) : store.put(ObjOrder);
      }

      if (window.location.pathname.includes("/login")) {
        sessionStorage.setItem("firebase-data-injected", "done");
        this.softReload(setForceRenderPage1, "/page1")
      }
      else if (window.location.pathname.includes("/page1")) this.softReload(setForceRenderPage1, "/page1")
      else if (window.location.pathname.includes("/orders"))
        if (+ObjOrder.order_status === 0) setForceRenderOrdersPage(uuidv4() + uuidv4());
        else this.softReload(setForceRenderOrdersPage, "/orders")
      else if (window.location.pathname.includes("/kds")) this.softReload(setForceRenderOrdersPage, "/kds")
      console.log('FOUND ORDER', ObjOrder)
    });
  }

  static RemoveOrderFromRunningDb(
    order_uuid,
    order,
    stateProps
  ) {

    const { setForceRenderOrdersPage, setForceRenderPage1 } = stateProps;
    let DBOpenReq = indexedDB.open("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    DBOpenReq.addEventListener("error", (err) => {
      console.warn(err);
    });

    DBOpenReq.addEventListener("success", (ev) => {
      let db = ev.target.result;
      let tx = db.transaction("running_orders", "readwrite");
      let store = tx.objectStore("running_orders");
      store.delete(order.order_uuid);
    })

    // console.log(order);
    if (order.order_uuid === order_uuid) {
      if (order.seat_uuid) {

        let onorder_seats = JSON.parse(localStorage.getItem("onorder_seats"));
        onorder_seats = onorder_seats
          .filter(seatOrder => seatOrder.uuid !== order.order_uuid);
        localStorage.setItem("onorder_seats", JSON.stringify(onorder_seats));

        if (window.location.pathname.includes("/page1")) {
          this.softReload(setForceRenderPage1, "/page1")
        }
      }
      else if (window.location.pathname.includes("/orders")) {
        this.softReload(setForceRenderOrdersPage, "/orders")
      }
    }
    else console.log("No order json received.");
  }

  static softReload(updateState, page) {
    clearTimeout(timeoutId);
    // console.log("timeoutId", timeoutId);

    timeoutId = setTimeout(() => {
      // console.log("initializing force render for " + page);
      updateState(uuidv4() + uuidv4());
    }, 3000);
  }
}

const running_order_firebase = new Running_order_firebase();
export default running_order_firebase;